import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class CheckReportComponent extends Vue {
    parameters: any = {};//参数
    homeWorkId: String = '';//作业id
    reportType: string = '';//报告类型
    compreReport: any = {};//综合检测报告
    crossCheckReport: any = {};//互查统计报告
    fullTextReport: any = {};//全文报告
    taskName: string = '';//学习任务
    activeName: string = '0';
    fullscreenLoading: Boolean = true;
    loadingText: string = '正在生成报告，请稍等';
    activeIndex: number = 0;//当前活动的索引

    indexRelation = {
        0: {
            report: 'compreReport',
        },
        1: {
            report: 'crossCheckReport',
        },
        2: {
            report: 'fullTextReport',
        }
    }

    reportTypeRelation = {
        'selfCheck': {
            url: '/api/checkreport/mutualcheckresult/',
            product: 'HWBC',
        },
        'chechDb': {
            url: '/api/checkreport/checkdbcheckresult/',
            product: 'HWSB',
        },
        'directional': {
            url: '/api/checkreport/directionalcheckresult/',
            product: 'HWDD',
        },
    }

    changeTabs(val) {
        this.getCheckDdReport(this.reportType, val);
    }

    //获取参数
    getParameter() {
        this.parameters = (<any>Object).assign({}, this.$route.query);
        this.homeWorkId = this.parameters.homeWorkId;
        this.reportType = this.parameters.type;
        this.taskName = this.parameters.taskName;
        this.getCheckDdReport(this.reportType, 0);
        //this.getCheckDdReport(this.reportType, 2);
    }
    //获取自建库、作业互查、定向检测检测报告（综合评估、互查统计、全文比对）
    getCheckDdReport(reportType, index) {
        this.fullscreenLoading = true;
        let reportTypeObj = this.reportTypeRelation[reportType];
        let options = {
            params: {
                reportType: index,
            }
        };
        this.axios.get(reportTypeObj.url + this.homeWorkId, options).then((data) => {
            this.fullscreenLoading = false;
            let datas = data.data;
            var reportObj;
            reportObj = this[this.indexRelation[index].report] = datas;
            let detectResult = reportObj.detectResult || {}
            reportObj._checkList = detectResult.recordHitInfoList;
            //根据index查找相似比
            reportObj._checkList && this.utilFun.matchIndex(reportObj._checkList, reportObj.detectResult.recordList);
            // dbid为报纸的，读取数据源不一样
            detectResult.recordList.forEach(item => {
                if (item.dbid == '报纸') {
                    item.dataBaseInfoMap.forEach(items => {
                        if (items.key == 'biaoti') {
                            item.title[0] = items.value;
                        }
                        if (items.key == 'zuozhe') {
                            item.creator[0] = items.value;
                        }
                        if (items.key == 'baoming') {
                            item.source = items.value;
                        }
                        if (items.key == 'riqi') {
                            item.date = items.value;
                        }
                    })
                }

                //如果是“期刊英文”就赋值中文“英文”
                if (item.dbid == "期刊英文") {
                    item.dbid = "英文";
                }
                if (item.dbid == "会议" || item.dbid == "期刊" || item.dbid == "学位") {
                    item.dbid = item.dbid + '论文';
                }

            });
            //学术库检测报告使用_recordList
            if (reportType == 'chechDb') {
                detectResult._recordList = [];
                detectResult.recordHitInfoList.forEach(item => {
                    let record = detectResult.recordList[item.recordIndex];
                    record.copyPercent = item.copyPercent
                    detectResult._recordList.push(record);
                })
                const noFangzhiData = detectResult._recordList.filter(item => item.dbid !== "方志");
                const groupedArrays = this.groupByFzbookid(detectResult._recordList);
                if (groupedArrays && groupedArrays.length > 0) {
                    const new_recordList: Array<any> = noFangzhiData.concat(groupedArrays)
                    if (new_recordList && new_recordList.length > 0) {
                        new_recordList.sort((a, b) => b.copyPercent - a.copyPercent);
                    }
                    detectResult._recordList = [...new_recordList]
                }
            } else {
                //根据dbid查找作业列表相关信息
                reportObj._checkList && reportObj._checkList.forEach(item => {
                    reportObj.checkItems.forEach(items => {
                        item.uDocumentID.indexOf(items.checkItemId)!=-1 && (items.copyPercent = item.copyPercent);
                    });
                });
                reportObj.checkItems = reportObj.checkItems && reportObj.checkItems.filter(item => {
                    return item.copyPercent;
                })
            }
            if (index == 2) {
                if (reportType != 'chechDb') {
                    //根据index查找dbid
                    detectResult.hitDetailInfoList && detectResult.hitDetailInfoList.forEach((item, index) => {
                        item.uDocumentID = reportObj.detectResult.recordList[item.recordIndex].uDocumentID;
                    });
                    //根据dbid添加作业相关信息
                    detectResult.hitDetailInfoList && detectResult.hitDetailInfoList.forEach(item => {
                        reportObj.checkItems.forEach(items => {
                            if (item.uDocumentID.indexOf(items.checkItemId) != -1) {
                                let _item = JSON.stringify(item);
                                item = (<any>Object).assign(item, items);
                                item.copyPercent = JSON.parse(_item).copyPercent;
                                item.length = JSON.parse(_item).length;
                            }
                        });
                    });
                } else {
                    //根据dbid添加作业相关信息
                    detectResult.hitDetailInfoList.forEach(item => {
                        let _item = JSON.stringify(item);
                        item = (<any>Object).assign(item, detectResult.recordList[item.recordIndex]);
                        //item.copyPercent = reportObj.detectResult.recordHitInfoList[item.recordIndex].copyPercent;
                        item.copyPercent = JSON.parse(_item).copyPercent;
                    });
                }

                //全文处理
                let fullText = reportObj.detectContent;//原文字符串
                let fullTextArr = [];//根据起始位置和长度截取的相似片段数组
                let fullTextStr = '';//处理后（添加属性和样式）的字符串
                detectResult.hitDetailInfoList && detectResult.hitDetailInfoList.forEach((item, index) => {
                    fullTextArr.push(fullText.substring(item.beginPosition, item.length + item.beginPosition));
                    item._hitText = item.hitText.replace(/(\r\n|\n|\r)+/g, "<br>");
                });

                fullTextStr = this.initReport(reportObj.detectContent, detectResult.hitDetailInfoList);

                //fullTextStr = fullText;
                //fullTextArr.forEach((item, index) => {
                //    if (index == this.activeIndex) {
                //        fullTextStr = fullTextStr.replace(item, `<span data-index=${index} class="color-red background-ccc">${item}</span>`);
                //    } else {
                //        fullTextStr = fullTextStr.replace(item, `<span data-index=${index} class="color-red">${item}</span>`);
                //    }
                //});
                //fullTextStr = fullTextStr.replace(/(\r\n|\n|\r)+/g, "<br />");
                this.fullTextReport._detectContent = fullTextStr;
            }
        })
    }
    
    groupByFzbookid(data) {
        const groupedData = {};
        const fangzhiData = data.filter(item => item.dbid === "方志");
        fangzhiData.forEach(item => {
            const fzbookidInfo = item.dataBaseInfoMap.find(info => info.key === "Fzbookid");
            if (fzbookidInfo) {
                const fzbookidValue = fzbookidInfo.value;
                if (!groupedData[fzbookidValue]) {
                    groupedData[fzbookidValue] = [];
                }
                groupedData[fzbookidValue].push(item);
            }
        });
        const inputArray: Array<any> = Object.values(groupedData);
        if (inputArray && inputArray.length > 0) {
            const mergedData = inputArray.map(group => {
                const {
                    articleId, conference, creator, dbid, uDocumentID, dataBaseInfoMap, date, dateSpecified, degree,
                    detectDate, detectDateSpecified, detectDateType, fullLength, fulltextLength, htmlPath, isDisplayFulltext,
                    isPublishedSelfCited, isReference, isSelfCited, isUnPublishedSelfCited, issue, paragraphNum, schoolFirst,
                    source, title, volumn
                } = group[0];
                return {
                    copyPercent: group.reduce((total, item) => total + item.copyPercent, 0),
                    articleId, conference, creator, dbid, uDocumentID, dataBaseInfoMap, date, dateSpecified, degree,
                    detectDate, detectDateSpecified, detectDateType, fullLength, fulltextLength, htmlPath, isDisplayFulltext,
                    isPublishedSelfCited, isReference, isSelfCited, isUnPublishedSelfCited, issue, paragraphNum, schoolFirst,
                    source, title, volumn
                };
            });

            return mergedData
        }
        
    }

    // 初始化报告
    initReport(htmlContentStr, HitDetailInfoList) {
        htmlContentStr = htmlContentStr || '';
        HitDetailInfoList = HitDetailInfoList || [];
        // 报告字符串转换成数组
        var htmlContentArry = htmlContentStr.split('');
        var htmlContent = '';
        // 循环相似片段
        var offset = 0;
        // 判断是否有相似比
        if (HitDetailInfoList.length > 0) {
            HitDetailInfoList.forEach((item, index) => {
                var hitText = htmlContentStr.substr(item.beginPosition, item.length);
                // 根据位置替换相似片段
                if (index == this.activeIndex) {
                    htmlContentArry.splice(item.beginPosition - offset, item.length, `<span data-index=${index} class="color-red background-ccc">${hitText}</span>`);
                } else {
                    htmlContentArry.splice(item.beginPosition - offset, item.length, `<span data-index=${index} class="color-red">${hitText}</span>`);
                }
                // 报告数组的偏移量
                offset = offset + item.length - 1;
            })
        }
        htmlContent = htmlContentArry.join('');
        htmlContent = htmlContent.replace(/\r\n/g, '<br />').replace(/\r/g, '<br />').replace(/\n/g, '<br />');
        return htmlContent;
    }

    changeActive(action, ele) {
        if ('operate' == action) {
            let target = ele.target;
            let targetName = target.nodeName;
            this.activeIndex = ele.target.dataset.index;
            if (targetName == 'SPAN') {
                for (let i = 0, len = document.querySelectorAll('span[data-index]').length; i < len; i++) {
                    let ele = document.querySelectorAll('span[data-index]')[i];
                    if (this.activeIndex == i) {
                        ele && (ele.className = 'color-red background-ccc');
                    } else {
                        ele && (ele.className = 'color-red');
                    }
                }
            }
        } else {
            for (let i = 0, len = document.querySelectorAll('span[data-index]').length; i < len; i++) {
                let ele = document.querySelectorAll('span[data-index]')[i];
                if (this.activeIndex == i) {
                    ele && (ele.className = 'color-red background-ccc');
                } else {
                    ele && (ele.className = 'color-red');
                }
            }
        }
    }
    changeStatus(index) {
        this.activeIndex = index;
        this.changeActive('trigger', null);
    }
    //返回上一页
    goBack() {
        this.$router.back();
    }
    //下载当前报告
    download() {
        let reportTypeObj = this.reportTypeRelation[this.reportType];
        let para = {
            homeWorkId: this.homeWorkId,
            taskName: this.taskName,
            product: reportTypeObj.product,
        };
        let url = this.utilFun.formatUrl(para, '/api/checkreport/reportdownload/' + this.homeWorkId, '/hw');
        this.utilFun.exportFiles(url);
    }
    mounted() {
        this.getParameter();
    }
}
